import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { f_isSignInWithEmailLink, f_signInWithEmailLink, auth } from '../Util/Firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, topMessageAtom, isAuthLoadedAtom } from '../../State';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as DotsSVG } from '../Images/buttons/topdots.svg';
import { ReactComponent as InfinieSVG } from '../Images/buttons/infiniteMeetingIcon.svg';
import { ReactComponent as MeetingSVG } from '../Images/buttons/newMeeting.svg';
import { ReactComponent as LiveSVG } from '../Images/buttons/newLive.svg';
import { ReactComponent as JoinSVG } from '../Images/buttons/join.svg';
import { ReactComponent as TrashSVG } from '../Images/buttons/Trash.svg';
import { ReactComponent as LiveLeftSVG } from '../Images/buttons/liveLeftIcon.svg';
import { ReactComponent as EditSVG } from '../Images/buttons/edit.svg';
import { ReactComponent as RecordedSVG } from '../Images/buttons/recordedButton.svg';
import DataModel from '../Util/DataModel';
import { format } from 'date-fns';

export default function RecordedItem({ meeting, callRecordedReload, setShowLiveState }) {
  const navigate = useNavigate(); //リダイレクト用
  const { t, i18n } = useTranslation();

  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const location = useLocation();

  useEffect(() => {
    //開始時間
    let date = new Date(meeting.postDate?._seconds * 1000);

    let formatDate;
    if (i18n.language == 'ja') {
      formatDate = format(date, 'MM' + '月' + 'dd' + '日 ' + 'h' + '時' + 'mm' + '分 ' + 'a' + ' ');
    } else {
      formatDate = format(date, 'MMM do hh:mm a');
    }

    setStartDate(formatDate);
  }, []);

  //新しいミーティング
  const joinMeeting = async (e) => {
    // e.stopPropagation();
    navigate('/r/' + meeting.id);
  };

  //クリップボードにコピー
  const copyURL = (e) => {
    e.stopPropagation();
    let url;
    url = 'https://faceless.ooo/r/' + meeting.id;

    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
    setShowMore(false);
  };

  //削除
  const deleteMeeting = async (e) => {
    e.stopPropagation();

    // 「はい」を選択した場合
    if (window.confirm(t('mypage.Do you want to delete it?'))) {
      console.log('「はい」を選択しました。');

      // 「いいえ」を選択した場合
    } else {
      console.log('「いいえ」を選択しました。');
      return;
    }

    setShowMore(false);

    let result = await DataModel.editRecorded(meeting.id, 'delete');
    if (result != null) {
      setTopMessageState({ type: 'copied', message: t('mypage.Deleted Successfully') });
      callRecordedReload();
      setShowMore(false);
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
  };

  //もっとを選択
  const showMoreNow = (e) => {
    e.stopPropagation();
    setShowMore(true);
  };

  return (
    <>
      <div className="listItemWrap" onClick={joinMeeting}>
        <div className="listItemIcon">
          <RecordedSVG />
        </div>
        <div className="listItemBody">
          <div className="listItemCategory">{startDate}</div>
          <div
            className="listItemTitle"
            style={{ wordWrap: 'break-word', '-webkit-line-clamp': '1' }}>
            {'faceless.ooo/r/' + meeting.id}
          </div>
        </div>
        <div className="listItemCopy" onClick={copyURL}>
          <CopyLinkSVG />
        </div>
        <div className="listItemMore" onClick={showMoreNow}>
          <DotsSVG />
        </div>
      </div>
      {/* ３ドット */}
      {showMore && (
        <>
          <div className="addAreaBack" onClick={() => setShowMore(false)}></div>
          <div className="moreAreaWrap">
            <div className="moreAreaItem" onClick={copyURL}>
              <CopyLinkSVG />
              <div>{t('mypage.Copy URL')}</div>
            </div>

            <div className="moreAreaItem" onClick={deleteMeeting}>
              <TrashSVG />
              <div style={{ color: '#FF0000' }}> {t('mypage.Delete')}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
